/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Serve_DescInputs */

const en_serve_desc = /** @type {(inputs: Serve_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build with the Claude or ChatGPT subscription you already pay for. Your computer does the work; Bystep keeps the plan, the proof and the phone preview.`)
};

const id_serve_desc = /** @type {(inputs: Serve_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bangun dengan langganan Claude atau ChatGPT yang sudah kamu bayar. Komputermu yang mengerjakan; Bystep memegang rencana, bukti, dan tampilan di HP.`)
};

/**
* | output |
* | --- |
* | "Build with the Claude or ChatGPT subscription you already pay for. Your computer does the work; Bystep keeps the plan, the proof and the phone preview." |
*
* @param {Serve_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const serve_desc = /** @type {((inputs?: Serve_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Serve_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_serve_desc(inputs)
	return en_serve_desc(inputs)
});